import React from "react";
import {
  Box,
  Flex,
  Input,
  Select,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Checkbox,
  Button,
  HStack,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function QuotesToolbar({
  searchTerm,
  onSearch,
  startDate,
  endDate,
  onStartDate,
  onEndDate,
  itemsPerPage,
  onPageSize,
  columns,
  toggleColumn,
  resetToday,
  resetLast7,
}) {
  return (
    <Flex mb={4} wrap="wrap" align="center" gap={3}>
      {/* Ricerca testo */}
      <Input
        placeholder="Cerca ID, note, importi..."
        value={searchTerm}
        onChange={(e) => onSearch(e.target.value)}
        maxW="240px"
      />

      {/* Shortcuts data */}
      <HStack spacing={1}>
        <Button size="sm" onClick={resetToday}>
          Oggi
        </Button>
        <Button size="sm" onClick={resetLast7}>
          Ultimi 7 gg
        </Button>
      </HStack>

      {/* Intervallo date */}
      <Flex align="center" gap={1}>
        <DatePicker
          selected={startDate}
          onChange={(d) => onStartDate(d)}
          placeholderText="Data inizio"
          dateFormat="yyyy-MM-dd"
          maxDate={endDate || new Date()}
          customInput={<Input size="sm" />}
        />
        <DatePicker
          selected={endDate}
          onChange={(d) => onEndDate(d)}
          placeholderText="Data fine"
          dateFormat="yyyy-MM-dd"
          minDate={startDate}
          customInput={<Input size="sm" />}
        />
      </Flex>

      {/* Righe per pagina */}
      <Select
        size="sm"
        value={itemsPerPage}
        onChange={(e) => onPageSize(+e.target.value)}
        maxW="100px"
      >
        {[15, 25, 50].map((n) => (
          <option key={n} value={n}>
            {n} righe
          </option>
        ))}
      </Select>

      {/* Selezione colonne */}
      <Menu>
        <MenuButton as={IconButton} icon={<HamburgerIcon />} size="sm" />
        <MenuList>
          {Object.keys(columns).map((col) => (
            <MenuItem key={col}>
              <Checkbox
                isChecked={columns[col]}
                onChange={() => toggleColumn(col)}
              >
                {col}
              </Checkbox>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Flex>
  );
}
